export default "__VITE_ASSET__CkkPGuyl__"